import { Grid, LinearProgress } from '@material-ui/core';
import { useStyles } from '@webapps/styles';

const AmountSection = ({ opcoRecord }) => {
  const { classes, css, cx, global } = useStyles(styles);
  
  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <div className={global.recordSection}>
          <div className={cx(global.title, global.blueBar)}>Montant pédagogique</div>
          <LinearProgress variant="determinate" value={78} />
        </div>
      </Grid>
      <Grid item xs={6}>
        <div className={global.recordSection}>
          <div className={cx(global.title, global.blueBar)}>Montant frais annexe réglé</div>
          <LinearProgress variant="determinate" value={78} />
        </div>
      </Grid>
    </Grid>
  );
};

const styles = ({ fontSizes }) => ({

});

export default AmountSection;